import React, { useState, useContext, useEffect } from 'react';
import { TicketContext } from '../../../../app/providers/TicketContext';
import { PanelContext } from '../../../../app/providers/PanelContext';
import { fetchWrapper } from '../../../../shared/api/fetchWrapper';
import { AuthContext } from '../../../../app/providers/AuthContext';

const EditTicketModal = ({ ticket, onClose }) => {
  const [tstat, setTstat] = useState(ticket.TSTAT);
  const [tdesc, setTdesc] = useState(ticket.TDESC);
  const [userexp, setUserExp] = useState(ticket.USEREXP);
  const [memid, setMemid] = useState(ticket.MEMID);
  const { selectTicket, fetchTickets, setEvents, selectedTicketId, setSelectedTicket, setSelectedTicketId, setTickets } = useContext(TicketContext);
  const { user } = useContext(AuthContext);

  const handleSave = async () => {
    // Modal'ı hemen kapat
    onClose();
    
    const body = {
      token: localStorage.getItem('token'),
      process: process.env.REACT_APP_UPDATE_TICKET_HEAD,
      TICID: ticket.TICID,
      CUSID: "1",
      MEMID: memid,
      TDESC: ticket.TDESC,
      USEREXP: userexp,
      PRIOR: "2",
      LOEKZ: null,
      TSTAT: tstat,
      LODAT: null,
      ANDAT: null
    };

    try {
      const response = await fetchWrapper(process.env.REACT_APP_UPDATE_TICKET_HEAD, body);
      
      if (response && response.result) {
        // Başarılı güncelleme - Ticket durumu kapalı yapıldıysa DOM'dan hemen kaldır
        if (tstat === "0") {
          // Ticket'ı tickets listesinden kaldır
          setTickets(prevTickets => prevTickets.filter(t => t.TICID !== ticket.TICID));
          
          // Eğer bu ticket seçiliyse events'i temizle ve ticket seçimini kaldır
          if (selectedTicketId === ticket.TICID) {
            setEvents([]); // Events'i temizle
            setSelectedTicket(null); // Seçili ticket'ı temizle
            setSelectedTicketId(null); // Seçili ticket ID'sini temizle
            
            // Not: setSelectedPanel('home') kaldırıldı - LeftPanel açık kalacak
            // RightPanel ve RightPanelChild otomatik olarak kapanacak çünkü selectedTicket null olacak
          }
        } else {
          // Ticket açık kalıyorsa normal işlemi yap
          selectTicket(ticket.TICID);
        }
        
        // Sunucudan güncel veriyi al
        fetchTickets();
        
        // Başarı mesajını göster (toast notification olarak)
      } else {
        // Hata durumu - Toast notification olarak göster
        //  console.error('❌ Ticket güncellenirken bir hata oluştu.');
      }
    } catch (error) {
      //console.error('Failed to update ticket:', error);
      // Hata durumu - Toast notification olarak göster
      //console.error('❌ Bağlantı hatası oluştu.');
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full transform transition-all duration-300 ease-in-out">
        <h2 className="text-xl font-semibold mb-4 text-gray-900">
          Bileti Düzenle
        </h2>
        
        {/* Form içeriği */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Sahibi
          </label>
          <input
            type="text"
            value={memid || ''}
            onChange={(e) => setMemid(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Açıklama
          </label>
          <input
            type="text"
            value={userexp}
            onChange={(e) => setUserExp(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="Bilet açıklamasını girin"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Durum
          </label>
          <select
            value={tstat}
            onChange={(e) => setTstat(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-md text-gray-900 focus:ring-500 focus:border-blue-500"
          >
            <option value="1">Açık</option>
            <option value="0">Kapalı</option>
          </select>
        </div>

        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded-md transition-colors duration-200"
          >
            İptal
          </button>
          <button
            onClick={handleSave}
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md flex items-center transition-all duration-200 transform hover:scale-105"
          >
            Kaydet
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditTicketModal;